import ibikeImage from './ibikelogo.jpg'
const IBikeLogo = () => {
  return ibikeImage
}

export default IBikeLogo
